export default "__VITE_ASSET__Dt68RJko__"